module.exports = __webpack_public_path__ + "static/media/cw.c0d83bf7.svg";